import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

const IntroSection = styled.section`
  padding: 80px 0;
  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
  position: relative;
  overflow: hidden;
  
  
  @keyframes float {
    0%, 100% { transform: translateY(0px) rotate(0deg); }
    50% { transform: translateY(-20px) rotate(5deg); }
  }
`;

const Container = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
  text-align: center;
`;

const IntroTitle = styled.h2`
  font-size: 2.5rem;
  font-weight: 700;
  color: var(--primary-blue);
  margin-bottom: 2rem;
  position: relative;
  display: inline-block;
  
  &::after {
    content: '';
    position: absolute;
    bottom: -10px;
    left: 50%;
    transform: translateX(-50%);
    width: 60px;
    height: 4px;
    background: var(--primary-orange);
    border-radius: 2px;
  }
  
  @media (max-width: 768px) {
    font-size: 2rem;
  }
`;

const IntroDescription = styled.p`
  font-size: 1.2rem;
  line-height: 1.8;
  color: #64748b;
  max-width: 800px;
  margin: 0 auto 3rem auto;
  animation: fadeInUp 0.8s ease-out 0.2s both;
  
  @keyframes fadeInUp {
    from {
      opacity: 0;
      transform: translateY(30px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
`;

const Introduction: React.FC = () => {
  const { t } = useTranslation();

  return (
    <IntroSection id="introduction">
      <Container>
        <IntroTitle>{t('intro.title')}</IntroTitle>
        <IntroDescription>{t('intro.description')}</IntroDescription>
      </Container>
    </IntroSection>
  );
};

export default Introduction;